import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import { classnames, TArg } from 'tailwindcss-classnames';
import { TextWithOptionalLineBreaks } from '../Heading';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

type ImageCaptionProps = {
  imageCaption?: Field<string>;
  classNames?: TArg;
};

const ImageCaption = ({ imageCaption, classNames }: ImageCaptionProps): JSX.Element => {
  const isExperienceEditor = useExperienceEditor();
  if (!imageCaption) {
    return <></>;
  }
  const extraClasses = classNames;
  if (isExperienceEditor || imageCaption?.value) {
    return (
      <div className={classnames('text-theme-image-caption-text', 'pt-5', 'text-sm', extraClasses)}>
        <TextWithOptionalLineBreaks tag="" field={imageCaption} />
      </div>
    );
  }
  return <></>;
};

export default ImageCaption;
